import AbstractObject from './object';
import Layer from './layer';
import ObjectView from '../views/object-view';

export default class AbstractGenerator extends AbstractObject {

  static orientation = {
    X: 'x',
    X_INVERT: 'x-invert',
    Y: 'y',
    Y_INVERT: 'y-invert'
  };

  constructor(options, defaultOptions = {}) {
    super(options, defaultOptions);

    this.layer3D = new Layer();
    this.layer2D = new Layer();
    this.draggableObjects = [];

    this.mode = this.options.mode || ObjectView.mode.MODE_3D;
  }

  get is3DMode() {
    return this.mode === ObjectView.mode.MODE_3D;
  }

  get is2DMode() {
    return this.mode === ObjectView.mode.MODE_2D;
  }

  get is2DEditorMode() {
    return this.mode === ObjectView.mode.MODE_2D_EDITOR;
  }

  init() {
    this.setOrientation();

    if (this.is2DMode) {
      this.init2DObject();
      this.object.set(this.layer2D); // VladP: Set the layer afterwards to prevent duplicate html labels in the snapshot
      this.set2DMode();
    } else if (this.is3DMode) {
      this.init3DObject();
      this.object.set(this.layer3D); // VladP: Set the layer afterwards to prevent duplicate html labels in the snapshot
      this.set3DMode();
    } else if (this.is2DEditorMode) {
      this.init2DEditorObject();
      this.object.set(this.layer2D); // VladP: Set the layer afterwards to prevent duplicate html labels in the snapshot
      this.set2DEditorMode();
    }

    // this.setOrientation();
    this.setHTMLOrientation();
  }

  setOrientation() {
    this.layer3D.mesh.rotation.x = 0;
    this.layer3D.mesh.rotation.y = 0;
    this.layer3D.mesh.rotation.z = 0;
    this.layer2D.mesh.rotation.x = 0;
    this.layer2D.mesh.rotation.y = 0;
    this.layer2D.mesh.rotation.z = 0;

    if (this.is3DMode) {
      switch (this.options.orientation) {
        case AbstractGenerator.orientation.X: {
          this.layer3D.mesh.rotation.y = Math.PI / 2;
          break;
        }
        case AbstractGenerator.orientation.X_INVERT: {
          this.layer3D.mesh.rotation.x = Math.PI;
          break;
        }
        case AbstractGenerator.orientation.Y: {
          this.layer3D.mesh.rotation.x = Math.PI / -2;
          this.layer3D.mesh.rotation.z = Math.PI / -2;
          break;
        }
        case AbstractGenerator.orientation.Y_INVERT: {
          this.layer3D.mesh.rotation.x = Math.PI / 2;
          this.layer3D.mesh.rotation.z = Math.PI / 2;
          break;
        }
        default: {
          break;
        }
      }
    }
  }

  setHTMLOrientation() {

  }

  init2DObject() {
    throw new Error('Implementation is necessary!');
  }

  set2DMode() {
    this.mode = ObjectView.mode.MODE_2D;
    this.layer2D.show();

    this.layer3D.hide();
  }

  init3DObject() {
    throw new Error('Implementation is necessary!');
  }

  set3DMode() {
    this.mode = ObjectView.mode.MODE_3D;

    this.layer2D.hide();
    this.layer3D.show();
  }

  init2DEditorObject() {
    throw new Error('Implementation is necessary!');
  }

  set2DEditorMode() {
    this.mode = ObjectView.mode.MODE_2D_EDITOR;

    this.layer2D.show();
    this.layer3D.hide();
  }

  clear() {
    super.clear();
    this.layer3D.clear();
    this.layer2D.clear();
    this.draggableObjects = [];
  }

}



// WEBPACK FOOTER //
// ./src/object-view/misc/generator.js